import { AxiosRequestConfig } from "axios";
import { WAITING_ROOM_SERVICE, getServiceHost } from "src/utils/Api";
import ApiClient from "src/utils/ApiClient";
import {
  IGroupedWaitingRoom,
  IMassActionsPayload,
  IWaitingRoomsDocument,
  PagedContent,
} from "./types";

type RequestConfig = Pick<AxiosRequestConfig, "signal">;

const PendingBenefitsApiClient = new ApiClient({
  baseURL: getServiceHost(WAITING_ROOM_SERVICE),
  headers: {},
}).client;

export const fetchWaitingRooms =
  (companyId: string, params: unknown) =>
  async ({
    signal,
  }: RequestConfig): Promise<PagedContent<IGroupedWaitingRoom>> => {
    const { data } = await PendingBenefitsApiClient.get(
      `/v2/waiting-room/company/${companyId}/waiting-rooms`,
      {
        params,
        signal,
      }
    );
    return data;
  };

export const fetchDocument =
  (documentId: string) =>
  async ({ signal }: RequestConfig): Promise<IWaitingRoomsDocument> => {
    const { data } = await PendingBenefitsApiClient.get(
      `/v2/waiting-room/documents/${documentId}`,
      {
        signal,
      }
    );
    return data;
  };

export const massAccept = async (
  payload: IMassActionsPayload
): Promise<void> => {
  const { data } = await PendingBenefitsApiClient.put(
    `/v2/waiting-room/mass-accept`,
    payload
  );
  return data;
};

export const massDecline = async (
  payload: IMassActionsPayload
): Promise<void> => {
  const { data } = await PendingBenefitsApiClient.put(
    `/v2/waiting-room/mass-cancel`,
    payload
  );
  return data;
};
